import {
  AssetAddAction,
  AssetUpdateAction,
  KalturaAsset,
  KalturaMediaAsset,
  KalturaMediaAssetArgs,
} from '@kaltura-ott/ott-client-types/api/types';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { kalturaClient } from '../kaltura-clent';

export const createAsset = (asset: KalturaMediaAssetArgs): Observable<KalturaAsset> => {
  const client = kalturaClient();
  asset.status = true;
  client.appendDefaultRequestOptions({ language: '*' });
  const action = new AssetAddAction({ asset: new KalturaMediaAsset(asset) });
  return client.request(action).pipe(
    catchError((err) => {
      return of(err);
    }),
  );
};

/**
 * Update KalturaMediaAsset
 * @param id
 * @param asset
 */
export const updateAsset = (id: number, asset: KalturaMediaAssetArgs): Observable<KalturaAsset> => {
  const client = kalturaClient();
  asset.status = true;
  client.appendDefaultRequestOptions({ language: '*' });
  const action = new AssetUpdateAction({
    id,
    asset: new KalturaMediaAsset(asset),
  });
  return client.request(action).pipe(
    catchError((err) => {
      return of(err);
    }),
  );
};

/**
 * Update any kaltura entity type
 * @param id
 * @param asset
 */
export const updateKalturaAsset = <T extends KalturaAsset>(id: number, asset: T): Observable<KalturaAsset> => {
  const client = kalturaClient();
  client.appendDefaultRequestOptions({ language: '*' });
  const action = new AssetUpdateAction({
    id,
    asset,
  });
  return client.request(action).pipe(
    catchError((err) => {
      return of(err);
    }),
  );
};
